// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  domain: 'dev.f-tep.com',
  baseUrl: 'https://dev.f-tep.com',
  s3ProxyUrl: 'https://dev.f-tep.com/s3',
  redirectUrl: 'https://dev.f-tep.com/app/', 
  postLogoutRedirectUri: 'https://dev.f-tep.com/app/', 
  clientId: 'ftep', 

  authPrefix: 'keycloak',
  resourceCataloguePrefix: 'resource-catalogue',
  resourceCatalogIdQueryPrefix: '/stac/collections/metadata:main/items/',
  dataAccessPrefix: 'data-access',
  workspaceApiPrefix: 'workspace-api',
  adesPrefix: 'zoo',
  userWorkspacePrefix: 'ws-',
  ftepUrl: 'https://f-tep.com/',
  helpdeskUrl: 'https://f-tep.com/get-started/#helpdesk',
  version: '1.3-dev',
  mapboxToken: 'pk.eyJ1IjoidmFuemV0dGVucCIsImEiOiJjaXZiZTM3Y2owMDdqMnVwa2E1N2VsNGJnIn0.A9BNRSTYajN0fFaVdJIpzQ',
  publicStacCatalogue: 'https://stac.dataspace.copernicus.eu/v1/'
};

export const ui_search_fields:any = {
  'SENTINEL-2': [
    {'queryable':'id','label':'Product ID contains'},
    {'queryable':'productType', 'label':'Product type', 'options':['S2MSI1C','S2MSI2A']},
    {'queryable':'cloudCover', 'label':'Maximum cloud cover (0-100)'},
  ]
}
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
